import { graphql } from '@api/mesa'

const REDEEM_POINTS_FOR_MORTGAGE_TRANSFER = graphql(`
  mutation RedeemPointsForMortgageTransfer(
    $numPoints: Int!
    $plaidAccountId: String!
    $idempotencyKey: String!
    $mortgageAddressId: String!
  ) {
    redeemPointsForMortgageTransfer(
      redeemPointsForMortgageTransferRequestDto: {
        numPoints: $numPoints
        plaidAccountId: $plaidAccountId
        idempotencyKey: $idempotencyKey
        mortgageAddressId: $mortgageAddressId
      }
    ) {
      plaidTransferAuthorizationId
    }
  }
`)

const CREATE_MORTGAGE_ADDRESS = graphql(`
  mutation CreateMortgageAddress($input: CreateMortgageAddressRequestDto!) {
    addMortgageAddress(addMortgageAddressRequestDto: $input) {
      id
      address1
      address2
      city
      state
      zip
      country
    }
  }
`)

export const PointsToCashForMortgageGqlMutations = {
  REDEEM_POINTS_FOR_MORTGAGE_TRANSFER,
  CREATE_MORTGAGE_ADDRESS,
}
